// import { Message } from 'element-ui';
import Vue from 'vue';
import { merge } from 'lodash';

import EnvUtils from '@/utils/EnvUtils';
import ctt from '@/utils/const';
import router, { resetRouter } from '@/router';
import store from '@/store';
import { i18n } from '@/locale/index';
import { deviceTypeReg } from '@/utils/dict';
import instance from '@/utils/axios';
import { isArray, isIterable, isNullOrUnDef, isString } from './is';
import { clearAll } from './auth';

/**
 * 判断pc还是移动端
 */
export function isPC() {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > -1) {
      flag = false;
      break;
    }
  }
  return flag;
}

/**
 * 数据保存到sessionStorage中
 * @param {由于存储的key} key
 * @param {存储的值} value
 */
export function setSessionItem(key, value) {
  sessionStorage.setItem(key, value);
}

/**
 * 获取sessionStorarge中存存储的值
 * @param {存储的key} key
 */
export function getSessionItem(key) {
  return sessionStorage.getItem(key);
}

/**
 * 数据保存到localStorage中
 * @param {用于存储的key} key
 * @param {存储的值} value
 */
export function setLocalItem(key, value) {
  localStorage.setItem(key, value);
}

/**
 * 获取localStorage中对应的值
 * @param {存储的key} key
 */
export function getLocalItem(key) {
  return localStorage.getItem(key);
}

/**
 * 获取token值
 */
export function getToken() {
  return getSessionItem(ctt.ADMIN_TOKEN);
}

/**
 * 格式化时间为1971-01-01 00:00:00
 * @param {时间} timestamp
 */
export function formatTimestamp(timestamp, split = '-') {
  if (!timestamp) {
    return '';
  }
  const now = new Date(timestamp);
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();

  return (
    year +
    split +
    pad0(month) +
    split +
    pad0(date) +
    ' ' +
    pad0(hour) +
    ':' +
    pad0(minute) +
    ':' +
    pad0(second)
  );
}

export function formatTime(timestamp) {
  // 格式化时间无时分秒
  if (!timestamp) {
    return '';
  }
  const now = new Date(timestamp);
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  return year + '-' + pad0(month) + '-' + pad0(date);
}

export function formatTimeMark(timestamp) {
  if (!timestamp) {
    return '';
  }
  const now = new Date(timestamp);
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();
  return `${year}${pad0(month)}${pad0(date)}${pad0(hour)}${pad0(minute)}${pad0(second)}`;
}
/**
 * 时间 年月日时分秒，根据时间判定显示
 * @param {时间/ms} time
 */
export function throughTime(t) {
  const time = parseInt(t);
  const yearSeconds = 365 * 24 * 3600;
  const monthSeconds = 30 * 24 * 3600;
  const daySeconds = 24 * 3600;

  if (time > yearSeconds || time === yearSeconds) {
    const year = Math.floor(time / yearSeconds);
    const month = Math.floor((time % yearSeconds) / monthSeconds);
    const day = Math.floor(((time % yearSeconds) % monthSeconds) / daySeconds);
    const hour = Math.floor((((time % yearSeconds) % monthSeconds) % daySeconds) / 3600);
    const minute = Math.floor(((((time % yearSeconds) % monthSeconds) % daySeconds) % 3600) / 60);
    return `${year}年${month}月${day}天${pad0(hour)}时${pad0(minute)}分`;
  } else if ((time < yearSeconds && time > monthSeconds) || time === monthSeconds) {
    const month = Math.floor(time / monthSeconds);
    const day = Math.floor((time % monthSeconds) / daySeconds);
    const hour = Math.floor(((time % monthSeconds) % daySeconds) / 3600);
    const minute = Math.floor((((time % monthSeconds) % daySeconds) % 3600) / 60);
    return `${month}月${day}天${pad0(hour)}时${pad0(minute)}分`;
  } else if ((time < monthSeconds && time > daySeconds) || time === daySeconds) {
    const day = Math.floor(time / daySeconds);
    const hour = Math.floor((time % daySeconds) / 3600);
    const minute = Math.floor(((time % daySeconds) % 3600) / 60);
    return `${day}天${pad0(hour)}时${pad0(minute)}分`;
  } else if (time < daySeconds) {
    const hour = Math.floor(time / 3600);
    const minute = Math.floor((time % 3600) / 60);
    const second = Math.floor((time % 3600) % 60);
    return `${pad0(hour)}时${pad0(minute)}分${pad0(second)}秒`;
  }
}

/**
 * 防抖，在事件被触发wait秒后再执行回调，如果在这wait秒内又被触发，则重新计时
 * @param {要执行的函数} func
 * @param {等待时间} wait
 * @param {第一次是否立即执行} immediate
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * 下载文件
 * @param {文件路径} url
 */
export function downFile(config, fileName) {
  return new Promise((resolve, reject) => {
    instance(
      merge(
        {
          responseType: 'blob'
        },
        config
      )
    )
      .then(res => {
        const a = document.createElement('a');
        if (navigator.msSaveBlob == null) {
          if (fileName) {
            a.download = fileName;
          } else {
            a.download = res.fileName;
          }
          a.href = URL.createObjectURL(res.blob);
          document.body.append(a); // 修复firefox中无法触发click
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          navigator.msSaveBlob(res.blob, res.fileName);
        }
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 通过表单post请求进入某一页面
 * @param {地址} url
 * @param {参数} params
 */
export function postToPage(url, params) {
  const temp = document.createElement('form');
  temp.action = url;
  temp.target = '_blank';
  temp.method = 'post';
  temp.style.display = 'none';
  if (params) {
    for (let item in params) {
      const opt = document.createElement('textarea');
      opt.name = params[item].name;
      opt.value = params[item].value;
      temp.appendChild(opt);
    }
  }
  document.body.appendChild(temp);
  temp.submit();
}

/**
 * 是否支持canvas
 */
export function isSupportCanvas() {
  var elem = document.createElement('canvas');
  return !!(elem.getContext && elem.getContext('2d'));
}

/**
 * 转化为百分数
 * @param {转化的数字} num
 * @param {保留小数} pos
 */
export function toPercent(num, pos) {
  // 百分数
  if (typeof num !== 'number') {
    console.error('第一个参数为数字');
  }
  if (typeof pos !== 'number' || Math.floor(pos) !== pos) {
    console.error('第二个参数为整数');
  }
  return (num * 100).toFixed(pos) + '%';
}

/**
 * 解析url参数为对象
 */
export function formatUrlParams(url) {
  let arr = url.split('?')[1].split('&');
  let obj = {};
  for (let i of arr) {
    obj[i.split('=')[0]] = i.split('=')[1];
  }
  return obj;
}

/**
 * 是否为本地
 */
export function isLocal() {
  return EnvUtils.is('native');
}

export function isIntranet() {
  return EnvUtils.is('intranet');
}

/**
 * 返回到登录页面
 */
export function backToLogin() {
  sessionStorage.clear();
  router.replace('/login');
  clearAll();
  resetRouter();
  return false;
}

/**
 * 设备整体状态
 * @param {设备状态} state
 * @param {运行状态} runstate
 */
export function formatDeviceState(state, runstate) {
  if (runstate === ctt.RUNSTATE_FAULT) {
    return ctt.POINT_STATE_FAULT;
  } else if (runstate === ctt.RUNSTATE_COLLECT) {
    return ctt.POINT_STATE_COLLECT;
  } else if (runstate === ctt.RUNSTATE_FIX) {
    if (state === ctt.POINT_STATE_CONNECT) {
      return ctt.POINT_STATE_FIX;
    } else {
      return state;
    }
  } else if (runstate === ctt.RUNSTATE_NORMAL) {
    return state;
  }
}

export function isCIAE_RMS(deviceType) {
  return [ctt.CIAE_RMS_E, ctt.CIAE_RMS_C].includes(deviceType);
}

/**
 * 是否为fcbr_100系列设备
 * @param {deviceType} 设备类型
 */
export function isFCBR(deviceType) {
  if (
    deviceType === ctt.FCBR_100B ||
    deviceType === ctt.FCBR_100F ||
    deviceType === ctt.FCBR_100PRO ||
    deviceType === ctt.FCBR_100_v1 ||
    deviceType === ctt.FCBR_100_v2 ||
    deviceType === ctt.FCBR_100G ||
    deviceType === ctt.FCBR_100CP ||
    deviceType === ctt.FCBR_100C ||
    deviceType === ctt.FCBR_100S1 ||
    deviceType === ctt.B02_V2 ||
    deviceType === ctt.FCBR_100GA ||
    deviceType === ctt.FCBR_100PROGA
  ) {
    return true;
  }
}

/**
 * 是否是 RG_05 设备
 * @param {*} deviceType 设备类型
 * @returns
 */
export function isRG_05(deviceType) {
  if (deviceType === ctt.RG_05) return true;
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 跳转新窗口
 * @param {路由信息} routeData
 */
export function windowOpen(routeData, name = '') {
  const res = router.resolve(routeData);
  const prefix = 'ht-';
  name = name ? prefix + name : '';

  const pathPrefix = res.href.startsWith('#') ? '#' : '';

  window.open(pathPrefix + res.resolved.fullPath + `?windowName=${name}`, name, '_blank');
}

export function normalizeWindowName() {
  if (/^ht-/.test(window.name)) return;
  window.name = '';
}

/**
 * 鉴别设备类型，未识别为default
 * @param {设备类型} deviceType
 */
export function whichDeviceType(deviceType) {
  let res = 'default';
  // let dt = parseInt(deviceType);
  deviceTypeReg.some(e => {
    const testFlag = e.reg.test(deviceType);
    if (testFlag) {
      res = e.name;
    }
    return testFlag;
  });
  return res;
}

export function canvasToImg() {
  return new Promise(resolve => {
    let imgs = {};
    setTimeout(() => {
      const canvas = document.getElementsByTagName('canvas');
      if (canvas && canvas.length > 0) {
        for (let i = 0; i < canvas.length; i++) {
          imgs[canvas[i].parentElement.parentElement.getAttribute('name')] =
            canvas[i].toDataURL('image/png');
        }
      }
      resolve(imgs);
    }, 2000);
  });
}
/**
 * 时间小于9加0
 * @param {} d
 */
function pad0(d) {
  return d < 10 && d > 0 ? '0' + d : d;
}

export function base64DataURLToArrayBuffer(dataURL) {
  const base64Regex = /^data:(image|img)\/(png|jpg|svg|svg\+xml);base64,/;
  if (!base64Regex.test(dataURL)) {
    return false;
  }
  const stringBase64 = dataURL.replace(base64Regex, '');
  let binaryString;
  if (typeof window !== 'undefined') {
    binaryString = window.atob(stringBase64);
  } else {
    binaryString = Buffer.from(stringBase64, 'base64').toString('binary');
  }
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}

export function blobToObj(data) {
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.readAsText(data, 'utf-8');
    reader.onload = function () {
      try {
        resolve(JSON.parse(reader.result));
      } catch (error) {
        console.error('[ERROR][blobToObj]', error);
      }
    };
  });
}

// 判断当前是否存在网络
export function checkLine() {
  return new Promise((resolve, reject) => {
    if (window.navigator.onLine) {
      const img = new Image();
      img.src = 'https://www.htvision.com.cn/static/image/unconnect.png';
      img.onload = () => resolve(true);
      img.onerror = () => reject(new Error());
    } else {
      reject(new Error());
    }
  });
}

export function dayTime() {
  const date = new Date();
  const todayYear = date.getFullYear();
  const todayMonth = date.getMonth();
  const today = date.getDate();
  return {
    begin: new Date(todayYear, todayMonth, today, '00', '00', '00'),
    end: new Date(todayYear, todayMonth, today, '23', '59', '59')
  };
}

export function getPreMonthRange() {
  const now = new Date(); // Get current date
  const previousMonth = new Date(now); // Create a copy of the current date

  previousMonth.setMonth(previousMonth.getMonth() - 1); // Subtract one month

  return [previousMonth.getTime(), now.getTime()];
}

/**
 * 创建一个map 并返回函数 用于检测key是否存在
 * @param {String} str example：1,2,3,4
 * @param {*} expectsLowerCase _
 * @returns {(val:string) => boolean}
 */
export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null);
  const list = str.split(',');
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? val => map[val.toLowerCase()] : val => map[val];
}

/**
 * 空语句
 */
export function noop() {}

/**
 * 跳转到错误页面
 * @param {*} code 404|500
 */
export function toErrorPage(code) {
  router.replace(`/error/${code}`);
}

/**
 * 校验值为 null|undefined||''
 * @param {*} v
 * @returns {Boolean}
 */
export function isEmpty(v, rule = [null, undefined, '']) {
  return rule.includes(v);
}

export function timer(fn, pause = 0) {
  const num = setTimeout(() => {
    clearTimeout(num);
    fn && fn();
  }, pause);
  return num;
}

/**
 * 取出对象中需要的属性
 * @param {{[index:String]: any}} target
 * @param {Array<String>} props
 * @returns {{[index:string]: any}}
 */
export function propFilter(target, props) {
  if (typeof target !== 'object') return {};
  if (!Array.isArray(props) || !props.length) return {};
  return props.reduce((map, key) => {
    if (target.hasOwnProperty(key)) map[key] = target[key];
    return map;
  }, {});
}

/**
 * 返回组件生成的VNode
 * @param {VueComponent} component
 * @param {any} data
 * @returns {import('vue').Component}
 */
export function genComponentInstance(component, data) {
  const Component = Vue.extend(component);
  const instance = new Component({ propsData: data || {}, store, router, i18n });
  return instance;
}

/**
 * 返回组件生成的dom节点
 * @param {VueComponent} component
 * @param {any} data
 * @returns {Element}
 */
export function genComponentVNode(component, data) {
  return genComponentInstance(component, data)._render();
}

/**
 * 返回组件生成的dom节点
 * @param {VueComponent} component
 * @param {any} data
 * @returns {Element}
 */
export function genComponentEl(component, data) {
  return genComponentInstance(component, data).$mount().$el;
}

export function useComponent(options, data) {
  const Compo = Vue.extend(options);

  const instance = new Compo({ propsData: data || {}, store, router, i18n });

  return instance;
}

export function getResolutionSymbol() {
  const { width } = document.body.getClientRects()[0];
  if (width < 768) {
    return 'xs';
  } else if (width >= 1920) {
    return 'xl';
  } else if (width >= 1200) {
    return 'lg';
  } else if (width >= 992) {
    return 'md';
  } else if (width >= 768) {
    return 'sm';
  }
}

/**
 * 转为数组
 * @param {any} value
 * @returns {any[]}
 */
export function arrify(value) {
  if (isNullOrUnDef(value)) {
    return [];
  }

  if (isArray(value)) {
    return value;
  }

  if (isString(value)) {
    return [value];
  }

  if (isIterable(value)) {
    return [...value];
  }

  return [value];
}

/**
 * @param { Promise<any> } promise
 * @param { Object } errorExt - Additional Information you can pass to the err object
 * @return { Promise<[Error, undefined] | [null, any]>  }
 */
export function awaitTo(promise, errorExt) {
  return promise
    .then(data => [null, data])
    .catch(err => {
      if (errorExt) {
        const parsedError = Object.assign({}, err, errorExt);
        return [parsedError, undefined];
      }

      return [err, undefined];
    });
}

/**
 * 字符串模板替换函数
 * @example replaceTemplate('{prefix}', {prefix: 'aaa'}) // "aaa"
 * @param {string} template
 * @param {Object} params
 * @returns
 */
export function replaceTemplate(template, params) {
  // 使用正则表达式匹配模板中的占位符，例如'{prefix}'
  var regex = /\{([^{}]+)\}/g;

  // 使用replace方法进行替换
  var result = template.replace(regex, function (match, key) {
    // 如果参数中存在与占位符对应的键值，则替换为参数的值，否则保持不变
    return params.hasOwnProperty(key) ? params[key] : match;
  });

  return result;
}

/**
 * 设置缺省值
 * @param {any} value
 * @param {any} defaultValue
 */
export function setDefaultValue(value, defaultValue) {
  if (isEmpty(value)) return defaultValue;

  return value;
}

export function recursionObj(obj, handler, opt) {
  opt = {
    children: opt?.children || 'children',
    distributor: [
      {
        validate: item => isArray(item[opt.children]) && !isEmpty(item[opt.children]),
        loop: true,
        key: 'default'
      }
    ].concat(opt?.distributor || [])
  };

  function exec(obj) {
    arrify(obj).forEach((e, i) => {
      opt.distributor.forEach(item => {
        if (!item.validate(e)) return;

        handler(e, obj, i, item.key);

        if (item.loop) {
          exec(e[opt.children]);
        }
      });
    });
  }

  exec(obj);
}

/**
 * @param {Object} arr  源数据
 * @param {Object} filterBy 过滤值
 */
export function filterArr(arr, filterBy) {
  const res = new Map();
  return arr.filter(item => !res.has(item[filterBy]) && res.set(item[filterBy], 1));
}

/**
 * 数组类型转对象
 * @param {*} array
 * @returns
 */
export function convertArrayToObject(array) {
  return array.reduce((result, item) => {
    result[item.value] = item.label;
    return result;
  }, {});
}

/**
 * sleep函数，可以await暂停指定毫秒数
 * @param {number} ms - 暂停的毫秒数
 * @returns {Promise<void>}
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function filterNonEmptyValues(obj) {
  const filtered = {};
  for (const [key, value] of Object.entries(obj)) {
    if (!isEmpty(value)) {
      filtered[key] = value;
    }
  }

  return filtered;
}

/**
 * 对比两个对象，返回不一致的字段组成的新对象
 * @param {Object} obj1 - 源对象
 * @param {Object} obj2 - 对比对象
 * @returns {Object} 包含不一致字段的新对象
 */
export function diffObjects(obj1, obj2) {
  if (!obj1 || !obj2) return {};

  const diff = {};

  // 获取所有唯一的键
  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  for (const key of allKeys) {
    // 处理嵌套对象的情况
    if (
      obj1[key] &&
      obj2[key] &&
      typeof obj1[key] === 'object' &&
      typeof obj2[key] === 'object' &&
      !Array.isArray(obj1[key]) &&
      !Array.isArray(obj2[key])
    ) {
      const nestedDiff = diffObjects(obj1[key], obj2[key]);
      if (Object.keys(nestedDiff).length > 0) {
        diff[key] = nestedDiff;
      }
    }
    // 处理数组的情况，不考虑顺序
    else if (obj1[key] && obj2[key] && Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
      const arr1 = [...obj1[key]].sort();
      const arr2 = [...obj2[key]].sort();

      if (JSON.stringify(arr1) !== JSON.stringify(arr2)) {
        diff[key] = {
          old: obj1[key],
          new: obj2[key]
        };
      }
    } else if (obj1[key] !== obj2[key]) {
      // 直接比较值
      diff[key] = {
        old: obj1[key],
        new: obj2[key]
      };
    }
  }

  return diff;
}

export function objTransfer(a, b) {
  Object.keys(a).forEach(key => {
    delete a[key];
  });

  Object.assign(a, b);

  return a;
}

// 获取地址栏参数
export function getUrlParams() {
  const params = {};

  const paramsStr = window.location.href.split('?')[1];

  if (isEmpty(paramsStr)) return params;

  paramsStr.split('&').forEach(item => {
    const [key, value] = item.split('=');
    params[key] = value;
  });

  return params;
}
